export default __webpack_public_path__ + "static/media/tool_firebase.60fddf5a.png";